<template>
    <div>
    <a-switch-field
      varName="mfa_options.totp.enabled"
      varLabel="One-time password (TOTP)"
      :varRequired="true"
      :varInitial="data.mfa_options.totp.enabled"
      :formLayout="formLayout"
      :size="size"
      :disabled="false"
      description="Time-based. Requires user to install Authenticator apps like Google Authenticator or Authy"
    />
    <a-switch-field
      varName="mfa_options.hotp.enabled"
      varLabel="One-time password (HOTP)"
      :varRequired="true"
      :varInitial="data.mfa_options.hotp.enabled"
      :formLayout="formLayout"
      :size="size"
      :disabled="false"
      description="HMAC-based. Requires user to install Authenticator apps like Google Authenticator or Authy."
    />
    <a-switch-field
      varName="mfa_options.backupcode.enabled"
      varLabel="Backup codes"
      :varRequired="true"
      :varInitial="data.mfa_options.backupcode.enabled"
      :formLayout="formLayout"
      :size="size"
      :disabled="false"
      description="Backup or recovery codes which can be saved somewhere safe for emergency use."
    />
    <a-switch-field
      varName="mfa_options.email.enabled"
      varLabel="Email"
      :varRequired="true"
      :varInitial="data.mfa_options.email.enabled"
      :formLayout="formLayout"
      :size="size"
      :disabled="false"
      description="One-time password sent by email"
    />
    <a-switch-field
      varName="mfa_options.sms.enabled"
      varLabel="SMS"
      :varRequired="true"
      :varInitial="data.mfa_options.sms.enabled"
      :formLayout="formLayout"
      :size="size"
      :disabled="true"
      description="One-time password sent by SMS"
    />
    <a-switch-field
      varName="mfa_options.trusted_device.enabled"
      varLabel="Trusted Device"
      :varRequired="true"
      :varInitial="data.mfa_options.trusted_device.enabled"
      :formLayout="formLayout"
      :size="size"
      :disabled="false"
      description="Allow user to trust the browser and skip two-factor authentication for next 30 days."
    />
    </div>
</template>

<script>
export default {
  props: {
    formLayout: String,
    size: String,
    data: Object
  }
}
</script>